import React from 'react';
import { Pressable, Text, View } from 'react-native';
import baseStyles from './forgottenNameButton.jss';
import { CachedImage } from 'LocalGluons/components/CachedImage';
import { t } from 'Locale';
import iconMap from 'LocalGluons/components/Icon/iconMap';

interface PressableButtonProps {
    onPress: () => void;
    title: string;
    icon: any;
    focus?: boolean;
}

const PressableButton: React.FC<PressableButtonProps> = ({ onPress, title, icon, focus }) => {
    return (
        <Pressable
            style={focus ? baseStyles.pressable : baseStyles.foccusedPressable}
            onPress={onPress}
        >
            <CachedImage
                tintColor={'white'}
                style={icon === iconMap.plan_product ? baseStyles.product : baseStyles.card}
                source={icon}
                resizeMode="stretch"
            />
            <View style={baseStyles.buttonTitleWidth}>
                <Text style={[baseStyles.buttonTitle, { marginTop: icon === iconMap.plan_product ? 30 : 40 }]}>
                    {t(title)}
                </Text>
            </View>
        </Pressable>

    );
};

export default PressableButton;